import { useEffect } from 'react';

import { FARBRO_SITE_ID } from '@/pages/aspiration/utils/constants';
import { useCompletedAspirationsQuery } from '@/services/opu-search/hooks';

export const useCompletedAspirations = ({
  date,
  siteId,
  location,
}: {
  date: string;
  siteId?: string | null;
  location?: string | null;
}) => {
  const isFarbro = siteId === FARBRO_SITE_ID;

  const { data, refetch, runRegular, runFbd } = useCompletedAspirationsQuery({
    date,
    siteId: siteId ?? null,
    isFarbro,
    location,
  });

  useEffect(() => {
    if (!siteId || !runRegular || !runFbd) return;

    if (isFarbro) {
      runFbd({ variables: { date, siteId, location: location ?? '' } });
    } else {
      runRegular({ variables: { date, siteId } });
    }
  }, [date, siteId, location, runRegular, runFbd, isFarbro]);

  return { data, refetch };
};
